import { render } from "./LeaveListTableHeader.vue?vue&type=template&id=78ad5c40&scoped=true"
import script from "./LeaveListTableHeader.vue?vue&type=script&lang=js"
export * from "./LeaveListTableHeader.vue?vue&type=script&lang=js"

import "./LeaveListTableHeader.vue?vue&type=style&index=0&id=78ad5c40&lang=scss&scoped=true"

import exportComponent from "/var/www/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78ad5c40"]])

export default __exports__